import createHttpClient from '../../axios/createHttpClient';
import { addEntities } from '../../../redux/reducers/entities';

const httpClient = createHttpClient();

// coach
// eslint-disable-next-line
export const getCoachList = (clientToken, clubId, config = {}) => dispatch => {
  const sendRequest = httpClient.get(`${clientToken}/clubs/${clubId}/coachs`, config).then(results => {
    dispatch(addEntities('coachs', results.data));
    return results;
  });
  return sendRequest;
};



// WEBPACK FOOTER //
// ./src/http-client/endpoints/coachApi/index.js